import { render } from "./add-products-category.vue?vue&type=template&id=17eb03f1&scoped=true"
import script from "./add-products-category.vue?vue&type=script&lang=js"
export * from "./add-products-category.vue?vue&type=script&lang=js"

import "./add-products-category.vue?vue&type=style&index=0&id=17eb03f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Haniel\\Desktop\\PROJECTS\\TANOU-ACADEMY\\e-commerce-webadmin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_2cebe3dcb9a4454fa15f9df2c44405de\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17eb03f1"]])

export default __exports__